module.exports = __webpack_public_path__ + "static/008-70950b51a9f4fca87e06cddff13f2b81.jpg";